import styled from '@emotion/styled';
import { borderRadii } from 'app/spacing';
import TableScrollContainer from '__components/Tables/ScrollContainer';
import { grayScale } from 'app/colors';
import BasicModal from '__components/Modals/presets/BasicModal';
import IconButton from '__components/Kizen/IconButton';
import { KizenTypography } from '__app/typography';
import ToggleButton from '__components/Kizen/ToggleButton';

export const StyledToggleButton = styled(ToggleButton)`
  && > button {
    height: 28px;
    width: 44px;
    padding-top: 0;

    span {
      height: 28px;
      width: 44px;
      padding-top: 0;
    }

    i {
      width: 14px;
      height: auto;

      svg {
        width: 14px;
        height: auto;
      }
    }
  }
`;

export const StyledViewSelector = styled.div`
  display: inline-flex;
  align-items: center;

  p {
    margin-right: 10px;
  }
`;

export const StyledLinkWrapper = styled.div`
  display: inline-block;
  max-width: 200px;
  overflow: hidden;
`;

export const TableWrapper = styled.div`
  width: 100%;
  flex: 1;
  background-color: ${grayScale.white};
  border-radius: ${borderRadii.small};
  overflow-y: hidden;
  flex-direction: column;
  position: relative;
  height: 100%;
  > div {
    position: relative;
    height: 100%;
  }
`;

export const PaginationWrapper = styled.div`
  width: 100%;
  flex: 0 0 45px;
  padding-top: 20px;
`;

export const StyledTableScrollContainer = styled(TableScrollContainer)`
  height: 100%;
`;

export const StyledModal = styled(BasicModal)`
  && .modal-body {
    overflow: visible;
  }
`;

export const StyledIconButton = styled(IconButton)`
  && svg {
    width: 15px;
    height: 15px;
  }
`;

export const StyledExecutionData = styled(KizenTypography)`
  font-family: 'Courier New', Monospace;
  font-size: 12px;
  white-space: pre-wrap;
  line-height: 1.5;
`;

export const StyledSwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`;
